import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { DialogTitle, DialogContent } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { PREFER_POD } from 'constants/common';

const PREFIX = 'PODThumbDown';

const classes = {
  content: `${PREFIX}-content`,
  title: `${PREFIX}-title`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.content}`]: {
    padding: '24px',
    color: theme.colorTokens.onSurfaceTextTitle,
    lineHeight: '1.5em',
    textAlign: 'center',
  },

  [`& .${classes.title}`]: {
    color: theme.colorTokens.onSurfaceTextTitle,
    textAlign: 'center',
  },
}));

const PODThumbDown = ({ handleClose, trackingCode }) => {
  return (
    <Root>
      <DialogTitle style={{ padding: '0 16px' }}>
        {handleClose && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <ClearIcon style={{ cursor: 'pointer' }} onClick={handleClose} />
          </div>
        )}
        <div className={classes.title}> Thank you for your feedback!</div>
      </DialogTitle>
      <DialogContent>
        <div className={classes.content}>
          We're sorry that it was not a good delivery photo for you. Please proceed to our{' '}
          <Link to={`/${trackingCode}/edit?reason=${PREFER_POD}`}>Manage Delivery</Link> feature to upload example delivery photos for future
          deliveries.
        </div>
      </DialogContent>
    </Root>
  );
};

export default PODThumbDown;
